/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pass_ActiveInputs */

const en_platform_pass_active = /** @type {(inputs: Platform_Pass_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const pl_platform_pass_active = /** @type {(inputs: Platform_Pass_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywny`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Platform_Pass_ActiveInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pass_active = /** @type {((inputs?: Platform_Pass_ActiveInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pass_ActiveInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pass_active(inputs)
	return en_platform_pass_active(inputs)
});